import Sidebar from "../components/Sidebar";
import ChatWindow from "../components/ChatWindow";

export default function Dashboard({ onOpenSearch }) {
  return (
    <div className="flex">
      <Sidebar />
      <ChatWindow onOpenSearch={onOpenSearch} />
    </div>
  );
}